export const LookupType = {
	Country: "country",
	Advert: "advert_public",
	Brand: "brand",
};
